"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Popover_1 = require("./Popover");
exports.default = Popover_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Popover/index.js
// module id = 1797
// module chunks = 8